/* Dialog Text */
import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import {
  ReportSubscriptionPrice,
  ReportSubscriptionLevel,
  ReportSubscriptionType,
  SubPeriodTypes,
} from "../../../api/models";
import { ReportExportService } from "../../../api/services";

export interface EditReportSubscriptionPriceDialogData {
  isNew: boolean;
  dialogTitle: string;
  reportSubscriptionPrice: ReportSubscriptionPrice;
  reportSubscriptionTypes: ReportSubscriptionType[];
  reportSubscriptionLevels: ReportSubscriptionLevel[];
  subscriptionPeriodTypes: SubPeriodTypes[];
  proposalFile: File;
  clearProposal: boolean;
}

@Component({
  selector: "edit-report-subscription-price-dialog",
  styleUrls: ["edit-report-subscription-price-dialog.component.css"],
  templateUrl: "./edit-report-subscription-price-dialog.component.html",
})
export class EditReportSubscriptionPriceDialogComponent {
  public Result: DialogResult;
  public filteredSubscriptionLevels: ReportSubscriptionLevel[];

  constructor(
    public dialogRef: MatDialogRef<EditReportSubscriptionPriceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditReportSubscriptionPriceDialogData,
    private reportExportService: ReportExportService
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    const callParams: ReportExportService.ReportExportCreateReportSubscriptionPriceParams = {
      proposalFileUpload: this.data.proposalFile,
      clearProposal: this.data.clearProposal,
      reportSubscriptionPriceCustomTerms: this.data.reportSubscriptionPrice.customTerms,
      reportSubscriptionPricePeriodTypeId: this.data.reportSubscriptionPrice.periodTypeId,
      reportSubscriptionPriceReportSubscriptionLevelId: this.data.reportSubscriptionPrice.reportSubscriptionLevelId,
      reportSubscriptionPriceReportSubscriptionTypeId: this.data.reportSubscriptionPrice.reportSubscriptionTypeId,
      reportSubscriptionPricePrice: this.data.reportSubscriptionPrice.price,
      reportSubscriptionPriceSuppressInvoice: this.data.reportSubscriptionPrice.suppressInvoice,
      reportSubscriptionPriceTaxRate: this.data.reportSubscriptionPrice.taxRate
    };

    if (this.data.isNew) {
      this.reportExportService
        .reportExportCreateReportSubscriptionPrice(callParams)
        .subscribe((result) => {
          this.Result.ResultType = DialogResultType.Ok;
          this.Result.ResultData = result;
          this.dialogRef.close(this.Result);
        }, (error) => alert(error.error)
        );
    } else {
      this.reportExportService
        .reportExportUpdateReportSubscriptionPrice(callParams)
        .subscribe((result) => {
          this.Result.ResultType = DialogResultType.Ok;
          this.Result.ResultData = result;
          this.dialogRef.close(this.Result);
        }, (error) => alert(error.error));
    }
  }

  selectedSubscriptionTypeChanged() {
    this.filteredSubscriptionLevels = this.data.reportSubscriptionLevels.filter(x => x.reportSubscriptionTypeId == this.data.reportSubscriptionPrice.reportSubscriptionTypeId);
  }

  handleFileInput(files: FileList) {
    this.data.proposalFile = files.item(0);
  }
}
